import Cisco from "public/cyberSecTechStack/cisco.png";
import Fortinet from "public/cyberSecTechStack/fortinet.png";
import PaloAlto from "public/cyberSecTechStack/paloalto.png";
import Sophos from "public/cyberSecTechStack/sophos.png";
import Crowdstrike from "public/cyberSecTechStack/crowdStrike.png";
import Radware from "public/cyberSecTechStack/radware.png";
import Eset from "public/cyberSecTechStack/eset.png";
import SentinelOne from "public/cyberSecTechStack/sentinelone.svg";

export const CYBER_SEC_TECH_STACK_CONSTANTS = {
  title: "Our Security Stack",
  list: [
    {
      name: "Cisco",
      logo: Cisco,
      link: "https://www.cisco.com/site/us/en/products/security/index.html",
    },
    {
      name: "PaloAlto",
      logo: PaloAlto,
      link: "https://www.paloaltonetworks.com/",
    },
    {
      name: "Fortinet",
      logo: Fortinet,
      link: "https://www.fortinet.com/",
    },
    {
      name: "Sophos",
      logo: Sophos,
      link: "https://www.sophos.com/",
    },
    {
      name: "Crowdstrike",
      logo: Crowdstrike,
      link: "https://www.crowdstrike.com/",
    },
    {
      name: "Radware",
      logo: Radware,
      link: "https://www.radware.com/",
    },
    {
      name: "Eset",
      logo: Eset,
      link: "https://www.eset.com/",
    },
    {
      name: "SentinelOne",
      logo: SentinelOne,
      link: "https://www.sentinelone.com/",
    },
  ],
};
